import { httpsCallable as firebaseHttpsCallable, type Functions } from 'firebase/functions';

interface CallableResult<T> {
  data: T;
}

type CallableFn<Req, Res> = (data?: Req) => Promise<CallableResult<Res>>;

export const httpsCallable = <Req = unknown, Res = unknown>(
  functionsInstance: Functions,
  functionName: string
): CallableFn<Req, Res> => {
  const callable = firebaseHttpsCallable<Req, { result?: Res } | Res>(functionsInstance, functionName);

  return async (data?: Req) => {
    try {
      const result = await callable(data);
      const payload = result.data;
      if (payload && typeof payload === 'object' && 'result' in (payload as Record<string, unknown>)) {
        return { data: (payload as { result?: Res }).result as Res };
      }
      return { data: payload as Res };
    } catch (error: any) {
      const err = new Error(error?.message || `Callable ${functionName} failed.`) as Error & {
        code?: string;
        details?: unknown;
      };
      err.code = error?.code || 'functions/internal';
      err.details = error?.details;
      throw err;
    }
  };
};
